import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { WindowService } from '../../providers/window/window.service';
import { MainContentClass } from '../../helpers/main-content.service.class';
import { ApiService } from '../../helpers/api.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'policy-privacity',
  standalone: true,
  imports: [],
  templateUrl: './policy-privacity.component.html',
  styleUrl: './policy-privacity.component.css'
})
export class PolicyPrivacityComponent extends MainContentClass {
  formG!: FormGroup;

  constructor(
    router: Router, route: ActivatedRoute,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) platformId: Object,
    public fb: FormBuilder,
    genericService: ApiService,
    private windowService: WindowService,
    private title: Title,
    private meta: Meta,
  ) {
    super(router, route,genericService,dialog ,platformId);
    this.formG = this.fb.group({
      idPais: ['',],
    });


  }

  ngOnInit(): void {
    this.hideLoader();
    this.title.setTitle('Políticas de Privacidad | Geovype');
    this.meta.addTags([
      { name: 'description', content: 'Geovype es tu app de seguridad con GPS, control parental y más.' },
      { name: 'keywords', content: 'app de seguridad, gps, control parental, rastreo, geolocalización, protección' },
      { property: 'og:title', content: 'Geovype - Seguridad en tus manos' },
      { property: 'og:description', content: 'App de seguridad, control parental, alertas GPS y mucho más.' },
      { property: 'og:image', content: 'https://geovype.com/assets/og-image.jpg' },
      { property: 'og:url', content: 'https://geovype.com/' }
    ]);
  }

  ngAfterViewInit(): void {
  }
}
